/** Shared front-end types for the global Timeline view (Plan → Timeline). */

export type TimelineGranularity = "day" | "week" | "month";

/** "none" renders one flat, unlabeled lane region (the spec's default).
 *  "type" splits by work-item kind (events vs tasks). "stage" splits by process
 *  stage (project scope only; needs a process selected on the project).
 *  "category" splits by the managed Category VALUE the server now emits on
 *  every item — the standard field, not the "type" kind. */
export type TimelineGroupBy = "none" | "user" | "team" | "project" | "type" | "stage" | "category";

/** Toggles in the toolbar's settings popover — each takes effect immediately. */
export interface TimelineSettings {
  showWeekends: boolean;
  showTimeOff: boolean;
  showHolidays: boolean;
}

export const DEFAULT_TIMELINE_SETTINGS: TimelineSettings = {
  // Weekends start hidden; time off & holidays start visible (product spec).
  showWeekends: false,
  showTimeOff: true,
  showHolidays: true,
};
